import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-student-profile',
  templateUrl: './student-profile.component.html',
  styleUrls: ['./student-profile.component.scss','../../../../../../assets/sass/pages/page-users.scss']
})
export class StudentProfileComponent implements OnInit {

  userId:any;
  userData:any;
  imageUrl=environment.apiUrls.imageUrl;


  constructor(private apiService:ApiService,private activatedroute:ActivatedRoute) { 
  //   this.activatedroute.paramMap.subscribe(params => { 
  //     this.userId = params.get('id'); 
  //     console.log('userId',this.userId)
     
  // });
  let localData=JSON.parse(localStorage.getItem('user'))
    this.userId=localData._id

  }

  ngOnInit(): void { 
    this.getUserById()
  }
  getUserById(){
    this.apiService.getEnrollByUserId(this.userId).subscribe((res:any)=>{
      this.userData = res?.data
    })
  }

}